import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=2882eefa&"
import script from "@/scripts/Mall/OrderDetail/index.js?vue&type=script&lang=js&"
export * from "@/scripts/Mall/OrderDetail/index.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports